import _classCallCheck from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import dayjs from 'dayjs';
import moment from 'moment';
import { BranchConstants } from '../constants';
import httpClient, { BASE_URL_API_V4_1, buildHttpClient } from './httpClient';
import { withRetry } from './RetryService';
export var API = /*#__PURE__*/function () {
  function API(httpClient) {
    _classCallCheck(this, API);

    _defineProperty(this, "httpClient", void 0);

    this.httpClient = httpClient;
  }

  _createClass(API, [{
    key: "getGroupClassSummaryList",
    value: function getGroupClassSummaryList(client_id, start_date, end_date) {
      return this.httpClient({
        method: 'get',
        url: '/consulting/group_class_summaries',
        params: {
          client_id: client_id,
          start_date: start_date,
          end_date: end_date
        }
      });
    }
  }, {
    key: "getGroupClassSummaryByID",
    value: function getGroupClassSummaryByID(client_id, id) {
      return this.httpClient({
        method: 'get',
        url: "/consulting/group_class_summaries/".concat(id),
        params: {
          client_id: client_id
        }
      });
    }
  }, {
    key: "createGroupClassSummary",
    value: function createGroupClassSummary(_ref) {
      var client_id = _ref.client_id,
          payload = _ref.payload;
      return this.httpClient({
        method: 'post',
        url: '/consulting/group_class_summaries',
        data: {
          client_id: client_id,
          group_class_summary: payload
        }
      });
    }
  }, {
    key: "updateGroupClassSummary",
    value: function updateGroupClassSummary(_ref2) {
      var id = _ref2.id,
          client_id = _ref2.client_id,
          payload = _ref2.payload;
      return this.httpClient({
        method: 'patch',
        url: "/consulting/group_class_summaries/".concat(id),
        data: {
          client_id: client_id,
          group_class_summary: payload
        }
      });
    }
  }, {
    key: "deleteGroupClassSummary",
    value: function deleteGroupClassSummary(id, client_id) {
      return this.httpClient({
        params: {
          client_id: client_id
        },
        method: 'delete',
        url: "/consulting/group_class_summaries/".concat(id)
      });
    }
  }, {
    key: "getTags",
    value: function getTags(tag_group_name) {
      return this.httpClient.get('/tags', {
        params: {
          tag_group_name: tag_group_name
        },
        baseURL: BASE_URL_API_V4_1
      });
    }
  }, {
    key: "getTagGroups",
    value: function getTagGroups(tag_group_names) {
      return this.httpClient.get('/tag_groups', {
        params: {
          tag_group_names: tag_group_names
        },
        baseURL: BASE_URL_API_V4_1
      });
    }
  }, {
    key: "signIn",
    value: function signIn(email, password) {
      return this.httpClient.post('/users/sign_in', {
        email: email,
        password: password,
        source: BranchConstants.APP_SOURCE,
        app_name: BranchConstants.APP_NAME
      });
    }
  }, {
    key: "getUserProfile",
    value: function getUserProfile(access_token) {
      return this.httpClient.get('/users/me', {
        headers: {
          Authorization: "Bearer ".concat(access_token),
          token: "".concat(access_token)
        },
        baseURL: BASE_URL_API_V4_1
      });
    }
  }, {
    key: "getUserBlood",
    value: function getUserBlood(client_id) {
      var max_results = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
      var end_date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : moment().format('YYYY-MM-DD');
      return this.httpClient.get('/blood_sugar_records', {
        params: {
          client_id: client_id,
          max_results: max_results,
          end_date: end_date
        }
      });
    }
  }, {
    key: "getBloodSugarDetail",
    value: function getBloodSugarDetail(client_id, date) {
      return this.httpClient.get('/blood_sugar_records/diary', {
        params: {
          client_id: client_id,
          date: date
        }
      });
    }
  }, {
    key: "updateMemo",
    value: function updateMemo(memoId, title, text, category, data) {
      return this.httpClient.patch("/client_memos/".concat(memoId), {
        title: title,
        text: text,
        category: category,
        data: data
      });
    }
  }, {
    key: "addMemo",
    value: function addMemo(clientID, title, text, category, data) {
      return this.httpClient.post("/clients/".concat(clientID, "/client_memos"), {
        title: title,
        text: text,
        category: category,
        data: data
      });
    }
  }, {
    key: "addSurveyMemo",
    value: function addSurveyMemo(clientID, text, survey_answer_id) {
      return this.httpClient.post("/clients/".concat(clientID, "/client_memos"), {
        title: '',
        text: text,
        record_id: survey_answer_id,
        record_type: 'survey_answer'
      });
    }
  }, {
    key: "pinOrUnpinMemo",
    value: function pinOrUnpinMemo(memoId, action) {
      return this.httpClient.post("/client_memos/".concat(memoId, "/").concat(action));
    }
  }, {
    key: "getMemos",
    value: function getMemos(clientID) {
      return this.httpClient.get("/clients/".concat(clientID, "/client_memos"));
    }
  }, {
    key: "removeMemo",
    value: function removeMemo(memoId) {
      return this.httpClient["delete"]("/client_memos/".concat(memoId));
    }
  }, {
    key: "createSubscription",
    value: function createSubscription(soap_id, user_id, client_id, date, medication_orders, branch_id) {
      return this.httpClient.post('/clinic_prescriptions', {
        soap_id: soap_id,
        user_id: user_id,
        client_id: client_id,
        date: date,
        medication_orders: medication_orders,
        branch_id: branch_id,
        last_update_user_id: user_id
      });
    }
  }, {
    key: "updateSubscription",
    value: function updateSubscription(id, soap_id, user_id, client_id, date, medication_orders, branch_id) {
      return this.httpClient.put("/clinic_prescriptions/".concat(id), {
        soap_id: soap_id,
        user_id: user_id,
        client_id: client_id,
        date: date,
        medication_orders: medication_orders,
        branch_id: branch_id,
        last_update_user_id: user_id
      });
    }
  }, {
    key: "returnDrug",
    value: function returnDrug(id, return_note) {
      return this.httpClient.post("pharmacy_stock_outgoings/".concat(id, "/return"), {
        return_note: return_note,
        id: id
      });
    }
  }, {
    key: "cancelReturnDrug",
    value: function cancelReturnDrug(id) {
      return this.httpClient.post("pharmacy_stock_outgoings/".concat(id, "/unreturn"), {
        id: id
      });
    }
  }, {
    key: "getChatrooms",
    value: function getChatrooms(_ref3) {
      var offset = _ref3.offset,
          limit = _ref3.limit,
          archived_after = _ref3.archived_after,
          q = _ref3.q;
      var params = {
        offset: offset,
        limit: limit,
        archived_after: archived_after
      };

      if (q) {
        params.q = q;
      }

      if (archived_after) {
        params.archived_after = archived_after;
      }

      return this.httpClient.get('/chats', {
        baseURL: BASE_URL_API_V4_1,
        params: params
      });
    }
  }, {
    key: "getChatroomInfo",
    value: function getChatroomInfo(chat_room_id) {
      return this.httpClient.get("/chat_rooms/".concat(chat_room_id), {
        baseURL: BASE_URL_API_V4_1
      });
    }
  }, {
    key: "getArchivedChatrooms",
    value: function getArchivedChatrooms(_ref4) {
      var archived_before = _ref4.archived_before,
          archived_after = _ref4.archived_after,
          token = _ref4.token,
          limit = _ref4.limit;
      return this.httpClient.get('/chats/archived_chats', {
        params: {
          archived_before: archived_before,
          archived_after: archived_after,
          pagination_token: token,
          limit: limit
        }
      });
    }
  }, {
    key: "pinChatroom",
    value: function pinChatroom(id) {
      return this.httpClient.post('/chats/pin', {
        chat_room_id: id
      });
    }
  }, {
    key: "unpinChatroom",
    value: function unpinChatroom(id) {
      return this.httpClient.post('/chats/unpin', {
        chat_room_id: id
      });
    }
  }, {
    key: "pinClient",
    value: function pinClient(clientID) {
      return this.httpClient.post("/clients/".concat(clientID, "/pin"));
    }
  }, {
    key: "unpinClient",
    value: function unpinClient(clientID) {
      return this.httpClient.post("/clients/".concat(clientID, "/unpin"));
    }
  }, {
    key: "getChatMemos",
    value: function getChatMemos(record_id) {
      return this.httpClient.get('/memos', {
        params: {
          record_id: record_id,
          record_type: 'chat'
        }
      });
    }
  }, {
    key: "addChatMemo",
    value: function addChatMemo(record_id, memo) {
      var _memo$title, _memo$text;

      return this.httpClient.post('/memos', {
        title: (_memo$title = memo.title) !== null && _memo$title !== void 0 ? _memo$title : '',
        text: (_memo$text = memo.text) !== null && _memo$text !== void 0 ? _memo$text : '',
        record_id: record_id,
        record_type: 'chat'
      });
    }
  }, {
    key: "getSurveyAnswers",
    value: function getSurveyAnswers(survey_form_id, client_id) {
      return this.httpClient.get('/surveys/surveys_answers', {
        params: {
          survey_form_id: survey_form_id,
          client_id: client_id
        }
      });
    }
  }, {
    key: "getSurveyTopicGuideAnswers",
    value: function getSurveyTopicGuideAnswers(survey_form_ids, client_id) {
      return this.httpClient.get('/surveys', {
        baseURL: BASE_URL_API_V4_1,
        params: {
          survey_form_ids: survey_form_ids,
          client_id: client_id
        }
      });
    }
  }, {
    key: "getProducts",
    value: function getProducts(_ref5) {
      var org_id = _ref5.org_id,
          productable_type = _ref5.productable_type;
      return this.httpClient.get("/orgs/".concat(org_id, "/products"), {
        params: {
          productable_type: productable_type
        }
      });
    }
  }, {
    key: "getProductsInCsv",
    value: function getProductsInCsv(responseType) {
      return this.httpClient.get('/product/csv', {
        responseType: responseType,
        params: {
          branch_id: BranchConstants.BRANCH_ID
        }
      });
    }
  }, {
    key: "downloadMedicineFormat",
    value: function downloadMedicineFormat() {
      return this.getProductsInCsv('blob');
    }
  }, {
    key: "uploadMedicineFormat",
    value: function uploadMedicineFormat(file) {
      var form = new FormData();
      form.append('file', file);
      form.append('branch_id', BranchConstants.BRANCH_ID);
      return this.httpClient.post('/product/csv', form);
    }
  }, {
    key: "uploadMedicinePresetGroupFormat",
    value: function uploadMedicinePresetGroupFormat(file) {
      var form = new FormData();
      form.append('file', file);
      form.append('branch_id', BranchConstants.BRANCH_ID);
      return this.httpClient.post('/pharmacy/medicine_preset_groups/csv_uploadings', form);
    }
  }, {
    key: "createOrder",
    value: function createOrder(payload) {
      return this.httpClient.post('/orders', {
        client_id: payload.client_id,
        user_id: payload.user_id,
        branch_id: payload.branch_id,
        order_date: dayjs().format('YYYY-MM-DD')
      });
    }
  }, {
    key: "updateOrder",
    value: function updateOrder(id, payload) {
      return this.httpClient.put("/orders/".concat(id), payload);
    }
  }, {
    key: "reassignOrder",
    value: function reassignOrder(id, payload) {
      return this.httpClient.post("/orders/".concat(id, "/reassigns"), payload);
    }
  }, {
    key: "discountOrder",
    value: function discountOrder(bill_id, payload) {
      return this.httpClient.post("/bills/".concat(bill_id, "/sales_allowances"), payload);
    }
  }, {
    key: "returnOrder",
    value: function returnOrder(bill_id, payload) {
      return this.httpClient.post("/bills/".concat(bill_id, "/sales_returns"), payload);
    }
  }, {
    key: "orderCancelAllProduct",
    value: function orderCancelAllProduct(id) {
      return this.httpClient.post("/orders/".concat(id));
    }
  }, {
    key: "updateOrderStatusToCheckoutProceeding",
    value: function updateOrderStatusToCheckoutProceeding(id, payload) {
      return this.httpClient.put("/orders/".concat(id, "/checkout_proceeding"), payload);
    }
  }, {
    key: "updateOrderStatusToBillProceeding",
    value: function updateOrderStatusToBillProceeding(id, payload) {
      return this.httpClient.put("/orders/".concat(id, "/bill_proceeding"), payload);
    }
  }, {
    key: "updateOrderStatusToPaymentProceeding",
    value: function updateOrderStatusToPaymentProceeding(id, payload) {
      return this.httpClient.put("/orders/".concat(id, "/payment_proceeding"), payload);
    }
  }, {
    key: "updateOrderStatusToCancel",
    value: function updateOrderStatusToCancel(id) {
      var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return this.httpClient.put("/orders/".concat(id, "/cancellation"), {
        order: {
          cancellation_reason: reason
        }
      });
    }
  }, {
    key: "returnOrderStatusToInitial",
    value: function returnOrderStatusToInitial(id, payload) {
      return this.httpClient.put("/orders/".concat(id, "/initial_returning"), payload);
    }
  }, {
    key: "returnOrderStatusToCheckoutInProgress",
    value: function returnOrderStatusToCheckoutInProgress(id, payload) {
      return this.httpClient.put("/orders/".concat(id, "/checkout_in_progress_returning"), payload);
    }
  }, {
    key: "getChatGallery",
    value: function getChatGallery(chatroomID) {
      return this.httpClient.get('/chats/attachments', {
        params: {
          chat_room_id: chatroomID
        }
      });
    }
  }, {
    key: "getClinicSOAP",
    value: function getClinicSOAP(id, client_id) {
      return this.httpClient.get("/clinic_soaps/".concat(id), {
        params: {
          client_id: client_id
        }
      });
    }
  }, {
    key: "checkIn",
    value: function checkIn(id) {
      return this.httpClient.post("/branch_visits/".concat(id, "/check_in"));
    }
  }, {
    key: "updateBranchVisitProviderName",
    value: function updateBranchVisitProviderName(id, payload) {
      return this.httpClient.post("/branch_visits/".concat(id, "/override_provider_name"), payload);
    }
  }, {
    key: "updateBranchVisit",
    value: function updateBranchVisit(id, payload, options) {
      return this.httpClient.put("/branch_visits/".concat(id), payload, options);
    }
  }, {
    key: "branchVisitConvertToOnline",
    value: function branchVisitConvertToOnline(id) {
      return this.httpClient.post("/branch_visits/".concat(id, "/convert_to_online"));
    } // create a new branch visit & upsert the client's profile

  }, {
    key: "createBranchVisit",
    value: function createBranchVisit(payload) {
      return this.httpClient({
        method: 'post',
        url: '/branch_visits',
        baseURL: BASE_URL_API_V4_1,
        data: payload
      });
    }
  }, {
    key: "cancelBranchVisit",
    value: function cancelBranchVisit(id) {
      return this.httpClient({
        method: 'post',
        url: "/branch_visits/".concat(id, "/cancellation"),
        baseURL: BASE_URL_API_V4_1
      });
    }
    /** @deprecated use hook `getClientRelationshipList` instead */

  }, {
    key: "getPinnedClientList",
    value: function getPinnedClientList(token) {
      return this.httpClient({
        method: 'get',
        url: '/service_lists/pinned_clients',
        baseURL: BASE_URL_API_V4_1,
        params: {
          pagination_token: token
        }
      });
    }
    /** @deprecated use hook `getClientRelationshipList` instead */

  }, {
    key: "getClientList",
    value: function getClientList(token) {
      return this.httpClient({
        method: 'get',
        url: '/service_lists/connected_clients',
        baseURL: BASE_URL_API_V4_1,
        params: {
          pagination_token: token
        }
      });
    }
    /** @deprecated use hook `getClientRelationshipList` instead */

  }, {
    key: "getClientGroupList",
    value: function getClientGroupList(token) {
      return this.httpClient({
        method: 'get',
        url: '/service_lists/group_classes',
        baseURL: BASE_URL_API_V4_1,
        params: {
          pagination_token: token
        }
      });
    }
  }, {
    key: "getClientRelationshipList",
    value: function getClientRelationshipList(_ref6) {
      var _ref6$limit = _ref6.limit,
          limit = _ref6$limit === void 0 ? 50 : _ref6$limit,
          _ref6$offset = _ref6.offset,
          offset = _ref6$offset === void 0 ? 0 : _ref6$offset,
          _ref6$end_date_within = _ref6.end_date_within_days,
          end_date_within_days = _ref6$end_date_within === void 0 ? 31 : _ref6$end_date_within;
      return this.httpClient({
        method: 'get',
        url: '/relationships',
        baseURL: BASE_URL_API_V4_1,
        params: {
          offset: offset,
          limit: limit,
          end_date_within_days: end_date_within_days
        }
      });
    }
  }, {
    key: "updateDispensationOrderItems",
    value: function updateDispensationOrderItems(id, payload) {
      return this.httpClient.put("/pharmacy/dispensation_orders/".concat(id), payload);
    }
  }, {
    key: "outputDispensationOrder",
    value: function outputDispensationOrder(payload) {
      return this.httpClient.post("/pharmacy/stock/output_orders", payload);
    }
  }, {
    key: "archiveDispensationOrder",
    value: function archiveDispensationOrder(id, payload) {
      return this.httpClient.put("/pharmacy/dispensation_orders/".concat(id, "/archive"), payload);
    }
  }, {
    key: "getClientSoap",
    value: function getClientSoap(soapId, clientID) {
      return this.httpClient.get("/clinic_soaps/".concat(soapId, "?client_id=").concat(clientID));
    }
  }, {
    key: "patchClientSoap",
    value: function patchClientSoap(soapId, clientID, payload, options) {
      return this.httpClient.patch("/clinic_soaps/".concat(soapId, "?client_id=").concat(clientID), payload, options);
    }
  }, {
    key: "makeSoapComment",
    value: function makeSoapComment(soapId, payload, options) {
      return this.httpClient.put("/clinic_soaps/".concat(soapId, "/make_comment"), payload, options);
    }
  }, {
    key: "updateInspectionReport",
    value: function updateInspectionReport(identityNumber) {
      return this.httpClient.post('/bot_requests/perform', {
        source_name: 'SOFT_BIO',
        identity_number: identityNumber
      });
    }
  }, {
    key: "getDiaries",
    value: function getDiaries(clients) {
      return this.httpClient({
        method: 'get',
        url: "/diaries/search_by_clients",
        params: {
          clients: clients
        }
      });
    }
  }, {
    key: "getFavoriteTemplates",
    value: function getFavoriteTemplates(_ref7) {
      var token = _ref7.token;
      return this.httpClient({
        method: 'get',
        url: '/note_asset_templates',
        params: {
          pagination_token: token
        }
      });
    }
  }, {
    key: "postFavoriteTemplate",
    value: function postFavoriteTemplate(payload) {
      return this.httpClient({
        method: 'post',
        url: '/note_asset_templates',
        data: payload
      });
    }
  }, {
    key: "deleteFavoriteTemplate",
    value: function deleteFavoriteTemplate(id) {
      return this.httpClient({
        method: 'delete',
        url: "/note_asset_templates/".concat(id)
      });
    }
  }, {
    key: "setTargets",
    value: function setTargets(clientID, params) {
      return this.httpClient({
        method: 'post',
        url: "/".concat(clientID, "/targets"),
        params: params
      });
    }
  }, {
    key: "patchTarget",
    value: function patchTarget(clientID, targetID, params) {
      return this.httpClient.patch("clients/".concat(clientID, "/targets/").concat(targetID), params);
    }
  }, {
    key: "importInBodyData",
    value: function importInBodyData(client_id, data) {
      return this.httpClient.post("/measurements/import_inbody_data", {
        client_id: client_id,
        data: data
      });
    }
  }, {
    key: "createPhalanx",
    value: function createPhalanx(clientID, data) {
      return this.httpClient.post("/measurements", {
        provider: 'phalanx',
        equip_model: 'phalanx',
        date: moment().format('YYYY-MM-DD'),
        client_id: clientID,
        data: data
      });
    }
  }, {
    key: "updateMeasurementOwner",
    value: function updateMeasurementOwner(reassigns) {
      return this.httpClient.post("/measurement/reassigns", {
        reassigns: reassigns
      });
    }
  }, {
    key: "exportDietReport",
    value: function exportDietReport(clientID, date) {
      return this.httpClient.get("/consulting/food_records.xlsx", {
        responseType: 'blob',
        params: {
          date: date,
          client_id: clientID
        }
      });
    }
  }, {
    key: "generateAiDailySummary",
    value: function generateAiDailySummary(payload) {
      return this.httpClient({
        method: 'post',
        url: "/generate_daily_summary",
        baseURL: '/cofitweeklysummary',
        data: payload
      });
    }
  }, {
    key: "generateDailySummarize",
    value: function generateDailySummarize(payload) {
      return this.httpClient({
        method: 'post',
        url: '/consulting/dietician_summaries',
        data: payload
      });
    }
  }, {
    key: "updateClient",
    value: function updateClient(payload) {
      return this.httpClient({
        method: 'put',
        url: "/clients/".concat(payload.id),
        data: payload
      });
    }
  }, {
    key: "createChatTemplate",
    value: function createChatTemplate(payload) {
      return this.httpClient({
        method: 'post',
        url: '/user_templates',
        baseURL: BASE_URL_API_V4_1,
        data: payload
      });
    }
  }, {
    key: "updateChatTemplate",
    value: function updateChatTemplate(payload) {
      return this.httpClient({
        method: 'patch',
        url: "/user_templates/".concat(payload.id),
        baseURL: BASE_URL_API_V4_1,
        data: payload
      });
    }
  }, {
    key: "deleteChatTemplate",
    value: function deleteChatTemplate(id) {
      return this.httpClient({
        method: 'delete',
        url: "/user_templates/".concat(id),
        baseURL: BASE_URL_API_V4_1
      });
    }
  }, {
    key: "getDiaryHistory",
    value: function getDiaryHistory(_ref8) {
      var clientID = _ref8.clientID,
          _ref8$start_date = _ref8.start_date,
          start_date = _ref8$start_date === void 0 ? dayjs().subtract(3, 'month').format('YYYY-MM-DD') : _ref8$start_date,
          _ref8$end_date = _ref8.end_date,
          end_date = _ref8$end_date === void 0 ? dayjs().format('YYYY-MM-DD') : _ref8$end_date,
          _ref8$limit = _ref8.limit,
          limit = _ref8$limit === void 0 ? 50 : _ref8$limit,
          _ref8$offset = _ref8.offset,
          offset = _ref8$offset === void 0 ? 0 : _ref8$offset;
      return this.httpClient({
        method: 'get',
        url: '/diaries',
        params: {
          client_id: clientID,
          start_date: start_date,
          end_date: end_date,
          limit: limit,
          offset: offset
        }
      });
    }
  }, {
    key: "createAnalysisGuide",
    value: function createAnalysisGuide(_ref9) {
      var soapID = _ref9.soapID;
      return this.httpClient({
        method: 'post',
        url: "/clinic_soaps/".concat(soapID, "/guide"),
        data: {
          guide: {
            clinic_soap_id: soapID
          }
        }
      });
    }
  }, {
    key: "updateAnalysisGuide",
    value: function updateAnalysisGuide(_ref10) {
      var soapID = _ref10.soapID,
          payload = _ref10.payload;
      return this.httpClient({
        method: 'put',
        url: "/clinic_soaps/".concat(soapID, "/guide"),
        data: payload
      });
    }
  }, {
    key: "updateClientInfo",
    value: function updateClientInfo(payload) {
      return this.httpClient({
        method: 'put',
        url: "/client_infos/".concat(payload.id),
        data: payload
      });
    }
  }, {
    key: "getInstantJobDailyCounts",
    value: function getInstantJobDailyCounts(params) {
      return this.httpClient({
        method: 'get',
        url: '/instant_job_daily_counts',
        params: params
      });
    }
  }, {
    key: "getInstantJobs",
    value: function getInstantJobs(params) {
      return this.httpClient({
        method: 'get',
        url: '/instant_jobs',
        params: params
      });
    }
  }, {
    key: "requestAvailableJobs",
    value: function requestAvailableJobs(data) {
      return this.httpClient({
        method: 'post',
        url: '/instant_jobs',
        data: data
      });
    }
  }, {
    key: "closeInstantJob",
    value: function closeInstantJob(_ref11) {
      var id = _ref11.id,
          send_notification = _ref11.send_notification,
          org_id = _ref11.org_id;
      return this.httpClient({
        method: 'put',
        url: "/instant_jobs/".concat(id),
        data: {
          send_notification: send_notification,
          org_id: org_id
        }
      });
    }
  }, {
    key: "getClientProfileByMobile",
    value: function getClientProfileByMobile(mobile) {
      return this.httpClient({
        method: 'get',
        url: "/orgs/".concat(BranchConstants.ORG_ID, "/client_profiles"),
        params: {
          'q[mobile_eq]': mobile
        }
      });
    }
  }, {
    key: "updatePaymentMethod",
    value: function updatePaymentMethod(bill_id, id, payload) {
      return this.httpClient({
        method: 'put',
        url: "/bills/".concat(bill_id, "/transaction_details/").concat(id),
        data: payload
      });
    }
  }, {
    key: "getPosOrders",
    value: function getPosOrders(_ref12) {
      var clientId = _ref12.clientId,
          storeId = _ref12.storeId;
      return this.httpClient({
        method: 'get',
        url: '/pq_store_orders',
        params: {
          client_id: clientId,
          belong_store: storeId
        }
      });
    }
  }, {
    key: "getMetabaseEmbededUrl",
    value: function getMetabaseEmbededUrl(_ref13) {
      var _ref13$dashboardId = _ref13.dashboardId,
          dashboardId = _ref13$dashboardId === void 0 ? 103 : _ref13$dashboardId,
          groupClassId = _ref13.groupClassId;
      return this.httpClient({
        method: 'post',
        url: "https://metabase-embed-service-148403284897.asia-east1.run.app/generate-embed-url",
        data: {
          dashboardId: dashboardId,
          params: {
            group_class_id: groupClassId
          }
        }
      });
    }
  }, {
    key: "getSimplyBookProviders",
    value: function getSimplyBookProviders() {
      return this.httpClient({
        method: 'get',
        url: '/simply_book_providers'
      });
    }
  }, {
    key: "getSoap",
    value: function getSoap(soap_id) {
      return this.httpClient({
        method: 'get',
        url: "/clinic/soaps/".concat(soap_id)
      });
    }
  }, {
    key: "getSoapListWithPrescription",
    value: function getSoapListWithPrescription(params) {
      return this.httpClient({
        method: 'get',
        url: '/clinic/soaps',
        params: params
      });
    }
  }, {
    key: "getPrescriptionsList",
    value: function getPrescriptionsList(orgID, params) {
      return this.httpClient({
        method: 'get',
        url: "/orgs/".concat(orgID, "/prescriptions"),
        params: params
      });
    }
  }, {
    key: "getDispensationOrdersList",
    value: function getDispensationOrdersList(orgID, params) {
      return this.httpClient({
        method: 'get',
        url: "/orgs/".concat(orgID, "/dispensation_orders"),
        params: params
      });
    }
  }, {
    key: "getDispensationOrder",
    value: function getDispensationOrder(orgID, orderID) {
      return this.httpClient({
        method: 'get',
        url: "/orgs/".concat(orgID, "/dispensation_orders/").concat(orderID)
      });
    }
  }, {
    key: "getPharmacyMedicineInventoryList",
    value: function getPharmacyMedicineInventoryList(orgID) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        today: dayjs().format('YYYY-MM-DD'),
        today_timestamp: dayjs().hour(0).minute(0).second(0).toISOString(),
        yesterday: dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      };
      return this.httpClient({
        method: 'get',
        url: "/orgs/".concat(orgID, "/pharmacy_medicine_inventory"),
        params: params
      });
    }
  }]);

  return API;
}();
var api = new API(httpClient);
export var apiWithRetry = new API(withRetry(buildHttpClient()));
export default api;